import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=29427641&scoped=true&"
import script from "./MainSection.vue?vue&type=script&lang=js&"
export * from "./MainSection.vue?vue&type=script&lang=js&"
import style0 from "./MainSection.vue?vue&type=style&index=0&id=29427641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29427641",
  null
  
)

export default component.exports